/**
 * Decide the desktop sidebar's collapsed state when the route crosses the "/me"
 * boundary.
 *
 * Entering a /me view collapses the sidebar for the visit — those views carry a
 * sticky tab bar that mirrors it. The collapse is transient: it must never
 * overwrite the user's saved preference. On leaving we restore whatever they had,
 * so a user who keeps the sidebar open gets it back and one who prefers it
 * collapsed is left alone.
 *
 * Returns the new collapsed value, or `null` when the route did not cross the
 * boundary (no change) — e.g. navigating between /me sub-pages, which must not
 * re-collapse or clobber a manual toggle made while on /me. (TASK-274)
 */
export const sidebarCollapsedOnMeTransition = (
    isMeView: boolean,
    wasMeView: boolean,
    savedPreferenceCollapsed: boolean,
): boolean | null => {
    if (isMeView === wasMeView) return null
    return isMeView ? true : savedPreferenceCollapsed
}
